import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a40f600c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section_scroll" }
const _hoisted_2 = { class: "news_message" }
const _hoisted_3 = { class: "news_head flex" }
const _hoisted_4 = { class: "news_name" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "news_more" }, "更多>", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "content_scroll"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "news_content" }
const _hoisted_11 = {
  key: 1,
  class: "content_scrolls"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "content_txt" }
const _hoisted_14 = { class: "content_text" }

import { ref} from 'vue';
import http from '@/api/home';
import { Carousel } from 'ant-design-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'OfferSide',
  emits: ['showStatused'],
  setup(__props, { expose, emit }) {

const aCarousel = Carousel;

const kvUrl = ref('');
const Hint = ref('');
const qrCodeUrl = ref('');
const displayType = ref(1);
const contentList = ref('');
const showStatus = ref<number>(1);


const kvInfo = ref([
  {
    kv_link: '',
    kv_url: '',
  },
]);
const customerService = ref({
  avatar_url: '',
  mobile: '',
  name: '',
});
const platformInformation = ref([
  {
    content_list: [
      {
        link: '',
        title: '',
      },
    ],
    mode_title: '',
    more_link: '',
    display_type: 1, //单排显示，2双排显示
  },
]);
const getuserGetInformation = () => {
  http.userGetInformation().then((res: any) => {
    const resData = res.data.data;
    kvUrl.value = resData.kv_url;
    showStatus.value = resData.status;
    emit('showStatused', showStatus.value);
    customerService.value = resData.customer_service;
    qrCodeUrl.value = resData.qr_code_url;
    Hint.value = resData.hint;
    platformInformation.value = resData.platform_information;
    resData.platform_information.forEach((item: any) => {
      item.content_list.forEach((item: any) => {
        contentList.value = item.title;
      });
      item.content_list.map((item: any) => {
        item.display_type = 1;
      });
    });
    kvInfo.value = resData.kv_info;
  });
};
expose({
  getuserGetInformation,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformInformation.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.mode_title), 1),
            _createElementVNode("a", {
              href: item.more_link,
              target: "_blank"
            }, _hoisted_7, 8, _hoisted_5)
          ]),
          (item.display_type == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content_list, (item1, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("a", {
                      href: item1.link,
                      target: "_blank"
                    }, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(item1.title), 1)
                    ], 8, _hoisted_9)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content_list, (item1, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("a", {
                      href: item1.link,
                      target: "_blank"
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(item1.title), 1)
                      ])
                    ], 8, _hoisted_12)
                  ]))
                }), 128))
              ]))
        ])
      ]))
    }), 128))
  ]))
}
}

})